import styled from '@emotion/native';
import { ViewStyle } from 'react-native';

interface SpacerProps {
  height?: number;
}

const Spacer = styled.View<SpacerProps>(
  ({ height }) =>
    ({
      width: '100%',
      height: height ?? undefined,
      flex: height ? 0 : 1,
    }) as ViewStyle,
);

export default Spacer;
